 /*=========================================================================================
  File Name: mutations.js
  Description: Products Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Products State Module
  Author: Tan Tran
==========================================================================================*/
export default {

    SET_PRODUCTS_STATE ( state, payload ) {
        
        state.products = payload;

    },

    SET_TAXES_STATE ( state, payload ) {
        state.taxes = payload
    },

    SET_CATEGORIES_STATE ( state, payload ) {

        let results = [];
        let map = new Map();

        for(let item of payload) {
            if(!map.has(item.categoryId)) {
                map.set(item.categoryId, true);
                results.push({
                    categoryId : item.categoryId,
                    categoryName : item.category
                });
            }
        }

        state.categoriesFromProductsList = results;

    },

    ADD_PRODUCT_STATE (state, payload) {
        state.products.push(payload);
    },

    UPDATE_PRODUCT_STATE (state, payload) {
       let index = state.products.findIndex(p => p.itemId == payload.itemId );
       
       if (index > -1) {
        state.products[index] = payload;
       }
    },

    UPDATE_PRODUCT_STATUS_STATE (state, payload) {
        let index = state.products.findIndex(p => p.itemId == payload.itemId );
       
       if (index > -1) {
        state.products[index].isOutOfStock = payload.isOutOfStock;
       }
    },

    UPDATE_PRODUCT_DISCOUNT_STATE (state, payload) {
        let index = state.products.findIndex(p => p.itemId == payload.itemId );
       
       if (index > -1) {
        state.products[index].discount = payload.discount;
       }
    },

    UPDATE_PRODUCT_PARENT_STATE( state, payload ) {
        let index = state.products.findIndex(p => p.itemId == payload.itemId );
       
       if (index > -1) {
        state.products[index].parentId = payload.parentId;
       }
    }
}